// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M6LPX3BiFlMKtg {
  display: flex;
  justify-content: flex-start;
}
.jHWwMDYERbD8WO {
  flex: 0 0 calc(25% - 8px);
  min-width: 120px;
  height: 128px;
  margin: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-skeleton, #091e420f);
}
@media only screen and (max-width: 600px) {
  .jHWwMDYERbD8WO {
    flex-basis: calc(33.3% - 8px);
  }
}
@media only screen and (max-width: 450px) {
  .jHWwMDYERbD8WO {
    flex-basis: calc(50% - 8px);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonBoardTilesWrapper": `M6LPX3BiFlMKtg`,
	"skeletonBoardTile": `jHWwMDYERbD8WO`
};
export default ___CSS_LOADER_EXPORT___;
